export default "__VITE_ASSET__Bm1siaBT__"